import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { ApiTopicsResponse } from '../lib/api/Taxonomies';

import { useApi } from '../contexts/ApiContext';

export default function useTopics(query = null, opts = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useQuery<ApiTopicsResponse>({
        queryKey: ['topics', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.taxonomies.topics(queryParam, null, null, { signal }),
        suspense: false,
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    const { data: items, pagination } = data || {};

    return data !== null
        ? {
              items,
              pagination,
              ...queryResult,
          }
        : queryResult;
}
